import { QueryClient as a } from "@tanstack/react-query";
let r = null;
function f({ isEnvTesting: e = !1 } = {}) {
  const n = {
    queries: {
      refetchOnMount: !1,
      refetchOnReconnect: !1,
      refetchOnWindowFocus: !1
    }
  };
  return e && (n.queries.retry = !1), new a(
    { defaultOptions: n }
  );
}
function o({ isEnvTesting: e = !1 } = {}) {
  return r === null && (r = f({ isEnvTesting: e })), r;
}
async function y(e, n, l) {
  return new Promise((u, c) => {
    e.mutate(
      n,
      {
        ...l,
        onSuccess: (t, ...s) => {
          u(t);
        },
        onError: (t, ...s) => {
          c(t);
        }
      }
    );
  });
}
export {
  o as getFallbackQueryClient,
  y as v4FriendlyMutateAsync
};
